import { Card } from "./card";

interface CenteredCardProps {
    children: React.ReactNode;
    maxWidth?: string;
}

export function CenteredCard({ children, maxWidth = "max-w-md" }: CenteredCardProps) {
    return (
        <div className="min-h-screen page-gradient pb-bottom-nav flex items-center justify-center">
            <Card className={`p-8 ${maxWidth}`}>{children}</Card>
        </div>
    );
}
